import React from "react";
import PropTypes from "prop-types";

import Page from "../../components/Page";
import CenteredPageContentContainer from "../../components/CenteredPageContentContainer";
import PaperContainer from "../../components/PaperContainer";
import ShiftEmployeesList from "../../c../../components/ShiftEmployeesList";
import ShiftForm from "../../components/forms/ShiftForm";
import FilesList from "../../components/FilesList";
import { FormMode } from "../../types/enums";
import { getFilesOfShift } from "../../actions/shiftActions";

const ShiftDetailPage = (props) => (
  <Page enableGoBack title="Dienst details">
    <CenteredPageContentContainer>
      <PaperContainer title="Dienstgegevens">
        <ShiftForm
          mode={FormMode.VIEW}
          shiftId={props.match.params.shift_id}
          isAccordion={true}
        />
      </PaperContainer>
    </CenteredPageContentContainer>
    <CenteredPageContentContainer>
      <PaperContainer title="Medewerkers van deze dienst">
        <ShiftEmployeesList shiftId={props.match.params.shift_id} />
      </PaperContainer>
    </CenteredPageContentContainer>
    <CenteredPageContentContainer>
      <PaperContainer title="Bestanden van deze dienst">
        <FilesList
          loadData={() => getFilesOfShift(props.match.params.shift_id)}
        />
      </PaperContainer>
    </CenteredPageContentContainer>
  </Page>
);

ShiftDetailPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      shift_id: PropTypes.string.isRequired,
    }),
  }),
};

export default ShiftDetailPage;



// WEBPACK FOOTER //
// ./src/pages/Shift/ShiftDetailPage.js